import Parser from '../bbcode/parser';
import messagesDE from '../config/messages_de'
import messagesEN from '../config/messages_en'
import messagesES from '../config/messages_es'
import messagesFR from '../config/messages_fr'
import messagesIT from '../config/messages_it'
import messagesNL from '../config/messages_nl'
import messagesPL from '../config/messages_pl'
import messagesPT from '../config/messages_pt'
import HelperContext from './HelperContext';

const messages = {
	de: messagesDE,
	en: messagesEN,
	es: messagesES,
	fr: messagesFR,
	it: messagesIT,
	nl: messagesNL,
	pl: messagesPL,
	pt: messagesPT
};

class Dico {

	static getMessage(country, lang, key, arg, argType, langArg) {
		if (country === null || (country !== undefined && country.length !== 2) || (lang !== undefined && lang.length !== 2)) {
			return key;
		}
		if (langArg == null) {
			langArg = lang;
		}
		var text = Dico.getTextFromI18nKey(key, lang);
		if (arg != null && argType != null) {
			var valueStr;
			var i = 0;
			if (argType === 'currency') {
				var currency = Dico.getCurrency(country);
				valueStr = new Intl.NumberFormat(`${langArg}-${country}`, { style: argType, currency: currency }).format(arg);
			} else if (argType === 'percent') {
				arg = arg / 100.0;
				valueStr = new Intl.NumberFormat(`${langArg}-${country}`, { style: argType }).format(arg);
			} else if (argType === 'integer') {
				valueStr = new Intl.NumberFormat(`${langArg}-${country}`, { style: 'decimal' }).format(arg);
			} else {
				valueStr = new Intl.NumberFormat(`${langArg}-${country}`, { style: argType }).format(arg);
			}
			text = text.replace(`{${i}}`, valueStr);
		}
		return text;
	}

	static getTextFromI18nKey(key, lang) {
		var text = key;
		if (messages[lang] != null && messages[lang][key] != null) {
			text = messages[lang][key];
		} else if (messages[lang] == null && messages['en'][key] != null) {
			text = messages['en'][key];
		} else if (messages[lang] != null && messages[lang][key] == null && messages['en'][key] != null) {
			text = messages['en'][key];
		}
		return text;
	}

	static getCurrency(country) {
		switch (country) {
			case 'GB':
				return 'GBP';
			case 'CH':
				return 'CHF';
			case 'PL':
				return 'PLN';
			default:
				return 'EUR';
		}
	}

	static getTextWithArguments(testArgs, data, amountNature, country, lang, guide) {
		if (country === null || country.length !== 2 || lang.length !== 2) {
			return testArgs.text;
		}
		var text = testArgs.text;
		var args = testArgs.arguments;
		var roundType = data.amountRounding || 'NO_ROUND';
		if (args != null && guide != null) {
			var i = 0;
			var mapArgs = Dico.buildMapArgsFromGuide(guide);
			for (var argKey in args) {
				var argName = args[argKey];
				var value = data[argName];
				var valueType = Dico.getValueType(argName, mapArgs[argName]);
				var regularPaymentSuffix;
				if (mapArgs[argName] === 'amountInclExclTax') {
					value = amountNature === 'HT' ? value.amountExclTax : value.amountInclTax;
					if (typeof value === 'number' && argName === 'regularPayment') {
						switch (roundType) {
							case 'CEIL_INT': value = Math.ceil(value); break;
							case 'NEAREST_INT': value = Math.round(value); break;
							default: break;
						}
					}
					regularPaymentSuffix = Dico.buildSuffix(argName, amountNature, country, lang);
				}
				var valueStr = Dico.getDoubleFormatted(value, country, lang, valueType, argName);
				text = Dico.buildFilledTextWithValuedVariable(text, valueStr, i, regularPaymentSuffix);
				i++;
			}
		}
		return Dico.getRichText(text);
	}

	static buildSuffix(argName, amountNature, country, lang) {
		var regularPaymentSuffix = null;
		if (argName === 'regularPayment') {
			regularPaymentSuffix = amountNature === 'HT' ?
				this.getMessage(country, lang, `generics.teaser.regularPayment.pmSuffix.exclTax.${country}`)
				: this.getMessage(country, lang, `generics.teaser.regularPayment.pmSuffix.inclTax.${country}`);
		}
		return regularPaymentSuffix;
	}

	static buildMapArgsFromGuide(guide) {
		var mapArgs = {};
		for (var guideKey in guide.amountInclExclTax) {
			mapArgs[guide.amountInclExclTax[guideKey]] = 'amountInclExclTax'
		}
		for (var guideKey1 in guide.amounts) {
			mapArgs[guide.amounts[guideKey1]] = 'amount'
		}
		for (var guideKey2 in guide.percentages) {
			mapArgs[guide.percentages[guideKey2]] = 'percentage'
		}
		return mapArgs;
	}

	static buildFilledTextWithValuedVariable(text, valueStr, argIndex, suffix) {
		if (suffix != null && suffix !== "") {
			text = text.replace(`{${argIndex}}`, `[b]${valueStr} ${suffix}[/b]`);
		} else {
			text = text.replace(`{${argIndex}}`, `[b]${valueStr}[/b]`);
		}
		return text;
	}

	static getValueType(argName, argValue) {
		var valueType;
		switch (argValue) {
			case 'amountInclExclTax':
				valueType = 'currency';
				break;
			case 'amount':
				valueType = 'currency';
				break;
			case 'percentage':
				valueType = 'percent';
				break;
			default:
				switch (argName) {
					case 'duration':
						valueType = 'duration';
						break;
					case 'annualMileage':
					case 'globalMileage':
						valueType = 'mileage';
						break;
					default:
						valueType = 'decimal';
						break;
				}
				break;
		}
		return valueType;
	}

	static getAmountFormatted(data, amountNature, country, lang) {
		if (data == null) {
			return '';
		}
		var value = amountNature === 'HT' ? data.amountExclTax : data.amountInclTax;
		if (value != null) {
			return Dico.getDoubleFormatted(value, country, lang, 'currency');
		} else {
			return '';
		}
	}
	static getIncrementAmountPerMonthFormatted(data, amountNature, country, lang) {
		if (data == null) {
			return '';
		}
		var value = amountNature === 'HT' ? data.amountExclTax : data.amountInclTax;
		if (value != null) {
			const prefix = value >= 0 ? '+' : '';
			const suffix = Dico.buildSuffix('regularPayment', amountNature, country, lang);
			const formattedValue = Dico.getDoubleFormatted(value, country, lang, 'currency');
			return `${prefix}${formattedValue} ${suffix}`;
		} else {
			return '';
		}
	}
	static getDoubleFormatted(value, country, lang, valueType, argName) {
		var propsFormat = { style: valueType }
		var suffix = '';
		if (valueType === 'currency') {
			var currency = Dico.getCurrency(country);
			propsFormat.maximumFractionDigits = 4;
			propsFormat.currency = currency;
		} else if (valueType === 'percent') {
			value /= 100.0;
			propsFormat.maximumFractionDigits = 6;
			HelperContext.updateMinDecimalFractionDigits(propsFormat, argName, country);
		} else if (valueType === 'duration') {
			suffix = ` ${Dico.getMessage(country, lang, 'generics.unit.months')}`;
			propsFormat.style = 'decimal';
		} else if (valueType === 'mileage' && country === 'GB') {
			suffix = ` ${Dico.getMessage(country, lang, 'generics.unit.miles')}`;
			propsFormat.style = 'decimal';
		} else if (valueType === 'mileage' && country !== 'GB') {
			suffix = ` ${Dico.getMessage(country, lang, 'generics.unit.km')}`;
			propsFormat.style = 'decimal';
		}
		return new Intl.NumberFormat(`${lang}-${country}`, propsFormat).format(value) + suffix;
	}

	static getRichText(text) {
		if (text == null) {
			return null;
		}
		let textWithoutStyle = text.replace(/\[td(?:\s+[^\]]*)?\](.*?)\[\/td\]/g, '[td]$1[/td]');
		textWithoutStyle = textWithoutStyle.replace(/\[th(?:\s+[^\]]*)?\](.*?)\[\/th\]/g, '[th]$1[/th]');
		const parserInst = new Parser();
		return parserInst.toReact(textWithoutStyle);
	}

	static getStyle(styleType, isIndent, isPrimaryText) {
		var style = { display: 'block' };
		if (styleType != null) {
			Dico.fillStyle(style, 'bold', styleType, isIndent);
			Dico.fillStyle(style, 'italic', styleType, isIndent);
			Dico.fillStyle(style, 'underlined', styleType, isIndent);
			if (styleType.displaySize != null) {
				switch (styleType.displaySize) {
					case 1:
						style['fontSize'] = 'small';
						break;
					case 3:
						if (isPrimaryText) {
							style['fontSize'] = 'x-large';
						} else {
							style['fontSize'] = 'large';
						}
						break;
					case 2:
					default:
						style['fontSize'] = 'medium';
						break;
				}
			}
			Dico.fillStyle(style, 'indent', styleType, isIndent);
		}
		return style;
	}

	static fillStyle(style, name, styleType, isIndent) {
		if (styleType[name]) {
			switch (name) {
				case 'bold':
					style['fontWeight'] = 'bold';
					break;
				case 'italic':
					style['fontStyle'] = 'italic';
					break;
				case 'underlined':
					style['textDecoration'] = 'underline';
					break;
				case 'indent':
					if (isIndent) {
						style['textIndent'] = '10px';
					}
					break;
				default:
					break;
			}
		}
	}
}

export default Dico
